import { Grid, Box } from "@mui/material";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { BarChart } from "@mui/icons-material";
import { DashboardCardGeneral } from "./components/DashboardCard/DashboardCardGeneral";
import { TemplateDefaultAdminConsole } from "../components/TemplateDefaultAdminConsole";
import { DashboardDataWorkspaceList } from "./components/DashboardDataWorkspaceList/DashboardDataWorkspaceList";
import { DashboardUpgradeBox } from "./components/DashboardUpgradeBox/DashboardUpgradeBox";
import { DashboardStoragePerUser } from "./components/DashboardStoragePerUser/DashboardStoragePerUser";
import { GetListWorkspacesWithStorageSizeByOrgInternalName, GetStorageSizeByOrgInternalName } from "../../../services/OrganizationServices";
import { useParams } from "react-router-dom";
import { StorageSizeInfoModel } from "../../../model/StorageSizeInfoModel";
import { WorkspaceStorageSizeInfoModel } from "../../../model/WorkspaceStorageSizeInfoModel";
import { KeyDriveDialog } from "../../../components/KeydriveComponents/Dialog/KeyDriveDialog";
import { useFreePlanDialog } from "../../../hooks/useFreePlanDialog";


export const DashboardAdmin = () => {
    const { nameOrg } = useParams();
    const [generalData, setGeneralData] = useState<StorageSizeInfoModel | null>(null);
    const [loadingGeneralData, setLoadingGeneralData] = useState(false);
    const [loadingWorkspaces, setLoadingWorkspaces] = useState(false);
    const [workspaceData, setWorkspaceData] = useState<WorkspaceStorageSizeInfoModel[]>([]);
    const { t } = useTranslation();
    const { shouldShowDialog, dialogProps } = useFreePlanDialog();

    useEffect(() => {
        if (!nameOrg) return;
        const fetchData = async () => {
            setLoadingGeneralData(true);
            setLoadingWorkspaces(true);

            try {
                const [generalData, workspacesData] = await Promise.all([
                    GetStorageSizeByOrgInternalName(nameOrg),
                    GetListWorkspacesWithStorageSizeByOrgInternalName(nameOrg)
                ]);

                if (generalData) setGeneralData(generalData);
                if (workspacesData) setWorkspaceData(workspacesData);
            } catch (err) {
                console.error('Erro ao carregar dados do dashboard:', err);
            } finally {
                setLoadingGeneralData(false);
                setLoadingWorkspaces(false);
            }
        };

        fetchData();
    }, [nameOrg]);

    if (shouldShowDialog) {
        return <KeyDriveDialog {...dialogProps} />;
    }

    return (
        <TemplateDefaultAdminConsole iconTitle={<BarChart />} title="Dashboard" subtitle={t('AdminConsole.DashboardSubtitle')}>
            <Grid container spacing={2} sx={{height: "100%"}}>
                {/* Left Side - Main Content */}
                <Grid item xs={12} md={6} lg={8} xl={9} sx={{height: 'calc(100% - 20px)'}}>
                    <DashboardCardGeneral loading={loadingGeneralData} data={generalData ? generalData : undefined} />
                    <DashboardDataWorkspaceList loading={loadingWorkspaces} data={workspaceData} />
                </Grid>
                <Grid item xs={12} md={6} lg={4} xl={3} sx={{height: '100%'}}>
                    {/* Right Side - Storage Usage */}
                    <Box sx={{ border: '1px solid #EAEAEA', padding: '14px', height: '100%', minHeight: '580px' }}>
                        <DashboardStoragePerUser />
                        <DashboardUpgradeBox />
                    </Box>
                </Grid>
            </Grid>
        </TemplateDefaultAdminConsole>
    );
};